/** @format */
import { Grid } from '@mui/material';
import { InputV2, InfoBox, UploadCropperImage } from 'components';
import { useFormContext } from 'react-hook-form';

const BaseInfo = ({ images, setImages, bizStatus, isLegal }) => {
  const methods = useFormContext();
  const noRegexp = new RegExp(/^[\u06F0-\u06F90-9]+$/);
  return (
    <>
      <InfoBox
        type="disable"
        content="در این بخش می‌توانید اطلاعات کسب‌وکار خود را تکمیل نمایید."
      />
      <Grid container item xs={12} spacing={3}>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="name"
            label="نام کسب‌وکار"
            register={methods.register}
            rules={['required', 'isLt|50']}
            fullWidth
            control={methods.control}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="username"
            label="نام کاربری"
            register={methods.register}
            fullWidth
            dir="ltr"
            control={methods.control}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={3}>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="legalInfo.shopName"
            label="نام فروشگاه"
            register={methods.register}
            rules={['isLt|50']}
            fullWidth
            control={methods.control}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="legalInfo.shopNameEn"
            label="نام انگلیسی فروشگاه"
            register={methods.register}
            rules={['isLt|50']}
            dir="ltr"
            fullWidth
            control={methods.control}
          />
        </Grid>
      </Grid>


      <Grid container item xs={12} spacing={3}>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="economicCode"
            label="کد اقتصادی"
            tooltip="کد اقتصادی در کسب‌وکارهای حقوقی اجباری است، صحت کداقتصادی در مرحله تایید کسب‌وکار، توسط کارشناسان پادیوم بررسی می‌شود  کسب‌وکارهای خانگی، شخصی و اصناف در صورت داشتن کد اقتصادی و درج آن، می‌توانند از سطوح مالی بالاتر برای  کسب‌وکار خود، استفاده کنند. وارد کردن کد اقتصادی برای کسب‌وکارهای خانگی، شخصی و اصناف اجباری نیست، اما هر شخص حقیقی می‌تواند تنها یک کسب‌وکار بدون کد اقتصادی تعریف کند. در صورت ثبت‌نام بیش از یک کسب‌وکار توسط یک شخص، کد اقتصادی برای کسب‌وکارهای بعدی، اجباری خواهد بود."
            register={methods.register}
            rules={['isNumeric', 'isEconomicCode']}
            fullWidth
            dir="ltr"
            englishNumber
            control={methods.control}
          />
        </Grid>
        {/* {isLegal && (
          <> */}
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="registrationNumber"
            label="شماره ثبت شرکت"
            defaultValue=""
            dir="ltr"
            englishNumber
            register={methods.register}
            rules={['isNumeric']}
            fullWidth
            control={methods.control}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="nationalCode"
            label="شناسه ملی"
            disabled={bizStatus === 'accepted'}
            defaultValue=""
            register={methods.register}
            rules={bizStatus !== 'accepted' ? ['isNumeric', 'isLength|11'] : null}
            fullWidth
            dir="ltr"
            englishNumber
            control={methods.control}
          />
        </Grid>
        {/* </>
        )} */}
      </Grid>
      <Grid container item xs={12} spacing={3}>
        <Grid item lg={6} md={6} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="sheba"
            label="شماره شبای حساب بانکی"
            tooltip="این شماره شبا برای انجام تسویه حساب دیجیتال یا حساب‌های تفصیلی شما استفاده می‌شود."
            defaultValue=""
            startAdornment={<div style={{ marginInlineEnd: 10 }}>IR</div>}
            onKeyPress={(e) => {
              if (!noRegexp.test(e.key)) {
                e.preventDefault();
              }
            }}
            register={methods.register}
            rules={['isNumeric', 'isShebaAccount']}
            englishNumber
            dir="ltr"
            fullWidth
            control={methods.control}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={3}>
        <Grid item lg={9} md={9} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="description"
            label="شرح فعالیت کسب‌وکاری"
            register={methods.register}
            rules={['required', 'isLt|400']}
            fullWidth
            multiline
            rows={5}
            useDefaultMultiline
            control={methods.control}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={3}>
        <Grid item lg={9} md={9} xs={12}>
          <InputV2
            errors={methods.formState.errors}
            name="link"
            label="لینک کسب و کار"
            register={methods.register}
            fullWidth
            rules={['isURLAndNotRequierd']}
            control={methods.control}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={3} >
        <Grid item >
          <UploadCropperImage
            title="تصویر لوگو کسب‌و‌کار"
            name="logo"
            value={images?.logo}
            onChange={(url) => setImages({logo: url, cover: images.cover})}
            isBusinessInfo={true}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <UploadCropperImage
            fullWidth
            title=" تصویر بنر کسب‌وکار"
            name="cover"
            value={images?.cover}
            onChange={(url) => setImages({ cover: url, logo: images.logo })}
            isBusinessInfo={true}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BaseInfo;
